import { ELanguage } from './common';
export enum EAuthority {
  ViewProfile = '/profile/view',
  ChangePassword = '/password/change',
  ViewDashboard = '/dashboard/view',
  ViewTransactions = '/transaction/view',
  CreateTransactions = '/transaction/create',
  ViewSearchOID = '/order/online/view',
  ExportTransactions = '/transaction/export',
  Refund = '/refund',
  ViewCustomerInfo = '/customerInfo/view',
  ViewUserManagement = '/account/view',
  EditUserRole = '/user-role/edit',
  ViewHelp = '/help/view',
  ViewPayment = '/payment/view',
  ExportPayment = '/payment/export',
  Subscription = '/subscription',
  ViewAmountReceivable = '/amountReceivable/view',
  ViewAnalytics = '/analytics/view',
  ViewAnalyticsOrder = '/analytics/order',
  ViewAnalyticsCustomerDemographic = '/analytics/customer-demographic',
  ViewAnalyticsOnlineTraffic = '/analytics/online-traffic',
  ViewAnalyticsOther = '/analytics/other',
}

interface IRoleRaw {
  roleId: string;
  roleName: string;
  description: string;
  type: EType;
}

export interface IRole extends IRoleRaw {
  createTime: number;
  isCreated: boolean;
  type: EType;
}

export interface IRoleDetail {
  roleName: string;
  authorityIds: number[];
  description?: string;
  type?: EType;
}

export interface IOutlet {
  outletId: string;
  outletName: string;
  isOnline?: boolean;
}

export interface IAuthrity {
  id: number;
  name: string;
  authority: EAuthority;
  description: string;
  subAuthorities?: IAuthrity[];
}

export enum EFirstStatus {
  NONE = 'NONE',
  CONTRACT_PASSWORD = 'CONTRACT_PASSWORD',
  CONTRACT = 'CONTRACT',
  PASSWORD = 'PASSWORD',
}

export interface ICurrentUserInfo {
  id: string;
  username: string;
  email: string;
  isCreated: boolean;
  createTime: number;
  roles: IRoleRaw[];
  language: ELanguage;
  outlet: {
    outletId: string;
    outletName: string;
    outletEmail: string;
    outletPhoneNumber: string;
    outletAddress: string;
    isOnline: boolean;
  };
  company: {
    companyName: string;
    companyEmail: string;
    companyPhoneNumber: string;
    companyAddress: string;
    companyId: string;
  };
  outlets: IOutlet[];
  authorities: IAuthrity[];
  firstStatus: EFirstStatus;
}

interface IUserBase {
  userId: string;
  username: string;
  email: string;
  type: EType;
}

export enum EType {
  COMPANY = 'COMPANY',
  MERCHANT = 'MERCHANT',
  NORMAL = 'NORMAL',
  TEMP_USER = 'TEMP_USER',
}
export interface IUser extends IUserBase {
  roleNames: string[];
  isCreated: boolean;
  createTime: number;
}

export interface IUserDetail extends IUserBase {
  roleIds: string[];
  outletIds: string[];
  createTime: number;
}

export interface IUserParams {
  username?: string;
  email?: string;
  roleIds: string[];
  outletIds: string[];
  password?: string;
}
